import {
  createRoleAsync,
  deleteRoleAsync,
  getAllRoleByLicenseAsync,
  getRoleByIdAsync,
  updateRoleAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateRoleAsync = () => useMutation(createRoleAsync);

export const useGetRoleByIdAsync = () => useMutation(getRoleByIdAsync);

export const useGetAllRoleByLicenseAsync = () =>
  useMutation(getAllRoleByLicenseAsync);

export const useUpdateRoleAsync = () => useMutation(updateRoleAsync);

export const useDeleteRoleAsync = () => useMutation(deleteRoleAsync);
